
const BoxData =  [
    {
        id: 1,
        on: true
    }, 
    {
        id: 2,
        on: true
    }, 
    {
        id: 3,
        on: false
    },
    {
        id: 4,
        on: true
    },
    {
        id: 5,
        on: true
    },
    {
        id: 6,
        on: false
    },
    {
        id: 7,
        on: false
    },
    {
        id: 8,
        on: true
    },
    {
        id: 9,
        on: false
    }
    ];
    export default BoxData;